import {
	getAdminDashboardRepository,
	getAdminInvitationRepository,
	getAdminMembershipRepository,
	getAdminOrganizationRepository,
	getAdminUserRepository,
	getAiAgentRepository,
	getCertificateRepository,
	getContractRepository,
	getDashboardRepository,
	getHubRepository,
	getInvestmentProposalRepository,
	getInvestmentRepository,
	getInvestorRepository,
	getModuleRepository,
	getNotificationRepository,
	getOrganizationRepository,
	getOrgInvitationRepository,
	getOrgMemberRepository,
	getProjectRepository,
	getPromoterProjectRepository,
	getPromoterRepository,
	getTemplateRepository,
	getUserProfileRepository,
} from "@/infrastructure/di";

import {
	getTokenService,
	getLocalStorageService,
	getOrgStorageService,
	getAiAgentSessionService,
	getFileDownloadService,
} from "@/infrastructure/di/services";

export function useNotificationRepository() {
	return getNotificationRepository();
}

export function useCertificateRepository() {
	return getCertificateRepository();
}

export function useDashboardRepository() {
	return getDashboardRepository();
}

export function useUserProfileRepository() {
	return getUserProfileRepository();
}

export function useModuleRepository() {
	return getModuleRepository();
}

export function useTemplateRepository() {
	return getTemplateRepository();
}

export function useInvestmentProposalRepository() {
	return getInvestmentProposalRepository();
}

export function useContractRepository() {
	return getContractRepository();
}

export function useInvestorRepository() {
	return getInvestorRepository();
}

export function useInvestmentRepository() {
	return getInvestmentRepository();
}

export function usePromoterRepository() {
	return getPromoterRepository();
}

export function useProjectRepository() {
	return getProjectRepository();
}

export function useOrganizationRepository() {
	return getOrganizationRepository();
}

export function useHubRepository() {
	return getHubRepository();
}

export function usePromoterProjectRepository() {
	return getPromoterProjectRepository();
}

export function useOrgInvitationRepository() {
	return getOrgInvitationRepository();
}

export function useOrgMemberRepository() {
	return getOrgMemberRepository();
}

export function useAdminDashboardRepository() {
	return getAdminDashboardRepository();
}

export function useAdminOrganizationRepository() {
	return getAdminOrganizationRepository();
}

export function useAdminUserRepository() {
	return getAdminUserRepository();
}

export function useAdminInvitationRepository() {
	return getAdminInvitationRepository();
}

export function useAdminMembershipRepository() {
	return getAdminMembershipRepository();
}

export function useAiAgentRepository() {
	return getAiAgentRepository();
}

export function useTokenService() {
	return getTokenService();
}

export function useLocalStorageService() {
	return getLocalStorageService();
}

export function useOrgStorageService() {
	return getOrgStorageService();
}

export function useAiAgentSessionService() {
	return getAiAgentSessionService();
}

export function useFileDownloadService() {
	return getFileDownloadService();
}
